import React, { useState } from "react";
import ConfirmationModal from "../components/ConfirmationModal";
import ContactInfoDialog from "./ContactInfoDialog";
import Proptypes from "prop-types";
import { Tooltip, Box } from "@mui/material";
import MessageTimer from "./MessageTimer";
import SendingSMSLayout from "./SendingSMSLayout";

const Switches = (props) => {
  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [isContactInfoOpen, setIsContactInfoOpen] = useState(false);

  const handleChange = (event) => {
    if((props.type === "call") || props.messagesCount === 0) {
      toggleConfirmationModal();
    }
  };

  const toggleConfirmationModal = () => {
    setIsConfirmationOpen(!isConfirmationOpen);
  };

  const confirmConfirmation = async () => {
    const { type } = props;

    if (type === "call") {
      toggleConfirmationModal();
      toggleContactInfoModal("");
      return;
    }
    
    toggleConfirmationModal();
    
    try {
      await props.sendSMS(props.data, props.sms);
    } catch (err) {
      console.log(err);
    }
  };

  const toggleContactInfoModal = (event) => {
    setIsContactInfoOpen(!isContactInfoOpen);
  };

  const handleContactConfirmation = async (contactInfo) => {
    try {
      await props.sendSMS(props.data, props.sms, contactInfo);
    } catch (err) {
      console.log(err);
    }
  };

  const SwitchTooltip = ({children}) => (
    (props.type === "call" && props.messagesCount > 0)
      ? <Tooltip title={
          <>
            You can send another <label className="capitalize">{props.title}</label> message.<br/>
            Messages sent: {props.messagesCount}
          </>
          }>
          <Box className='inline-block'>
            {children}
          </Box>
        </Tooltip>
      : <Box className='inline-block'>
          {children}
        </Box>
  );

  return (
    <Box className='w-100 flex justify-center'>
      <SwitchTooltip>
        {
          (props?.countdown || props.isSendingSms) &&
          <SendingSMSLayout>
            {props?.countdown ?
              <MessageTimer futureTime={props.sms_eta} />
              :
              <span className="text-sm">Sending...</span>
            }
          </SendingSMSLayout>
        }
        <label
          className={`switch switch-track 
            ${
              props.hasSent ? "switch-not-checked" : "switch-checked"
            }
            ${
              props?.countdown ? " switch-blur" : ""
            }
          `}
          text-switch={props.text}
          text-status={props.status ? props.status: ''}
          aria-label="secondary checkbox"
        >
          <input
            type="checkbox"
            disabled={props.disabled || props.isRowSendingSms}
            onChange={handleChange}
            checked={props.disabled || props.hasSent}
            name="checked"
          />

          <span
            className={`text-xs font-medium slider round 
            ${
              props.status === "FAILED"
                ? "slider-failed"
                : props.status === "SENT"
                ? "slider-success"
                : ""
            }
            ${props.disabled ? "slider-disabled" : "slider-enabled"}
            ${(props.type === "call" && props.messagesCount > 0) ? "show-icon" : ""}
            `}
          />
        </label>
      </SwitchTooltip>
      {isConfirmationOpen && (
        <ConfirmationModal
          confirmConfirmation={() => confirmConfirmation()}
          toggleModal={toggleConfirmationModal}
          messagesCount={props.messagesCount}
          type={
            props.type === "call"
              ? "Call Store"
              : props.type === "beBack"
              ? "BeBack"
              : props.type === "vehicleReady"
              ? "Vehicle Ready"
              : null
          }
          name={props.data.Name}
        />
      )}
      {isContactInfoOpen && (
        <ContactInfoDialog
          open={isContactInfoOpen}
          toggle={toggleContactInfoModal}
          confirm={handleContactConfirmation}
        ></ContactInfoDialog>
      )}
    </Box>
  );
};

Switches.propTypes = {
  data: Proptypes.object,
  disabled: Proptypes.oneOfType([Proptypes.bool, Proptypes.number]),
  hasSent: Proptypes.bool,
  sendSMS: Proptypes.func,
  sms: Proptypes.string,
  text: Proptypes.string,
  type: Proptypes.string,
  messagesCount: Proptypes.number,
  title: Proptypes.string
};

export default Switches;
